export default __webpack_public_path__ + "static/media/Step3-Lovrican.8fb03aea.svg";